module.exports = __webpack_public_path__ + "img/logo-sd-tp.bcc4573f.png";